import { render } from "./Show.vue?vue&type=template&id=dffb027c&scoped=true&lang=pug"
import script from "./Show.vue?vue&type=script&lang=ts"
export * from "./Show.vue?vue&type=script&lang=ts"

import "./Show.vue?vue&type=style&index=0&id=dffb027c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dffb027c"

export default script